export const TEMPLATE_SCOPE = process.env.REACT_APP_BOX_TEMPLATE_SCOPE;
export const TEMPLATE_KEY = process.env.REACT_APP_BOX_TEMPLATE_KEY;
